import adaptecca from '../adaptecca.json';
import imagenes from '../imagenes.json';

const adaptecaFormmated = Object.keys(adaptecca)
  .map(key => {
    const value = adaptecca[key];
    return [Date.parse(key), value];
  });

const imagenesFormatted = Object.keys(imagenes)
  .map(key => {
    const value = imagenes[key];
    return [Date.parse(key), value];
  });


export default function () {
  return {

    tooltip: {
      valueDecimals: 2,
    },

    exporting: {
      enabled: false,
    },

    chart: {
      type: 'spline',
      zoomType: 'x',
      style: {
        fontFamily: 'roboto, arial'
      }
    },

    title: {
      text: false
    },

    subtitle: {
      text: false
    },

    xAxis: {
      title: {
        text: this.$t('fecha')
      },
      type: 'datetime',
      tickInterval: 365 * 24 * 3600 * 1000,
      dateTimeLabelFormats: {
        year: '%Y'
      }
    },

    yAxis: {
      title: {
        text: this.$t('indicadores.temperatura') + ' (ºC)'
      }
    },

    legend: {
      layout: 'vertical',
      align: 'center',
      verticalAlign: 'top',
      floating: true,
      backgroundColor: this.$store.getters.isDarkTheme ? '#000000' : '#FFFFFF',
      borderWidth: 2
    },

    plotOptions: {
      spline: {
        marker: {
          enabled: true
        }
      },
    },

    series: [{
      name: this.$t('predictivos.tmin_adapteca'),
      data: adaptecaFormmated,
      color: '#ffeb3b'
    }, {
      name: this.$t('predictivos.tmin_imagen'),
      data: imagenesFormatted,
      color: '#388e3c'
    }]
  }
}


// WEBPACK FOOTER //
// ./src/components/core/predictivos/charts/chart1.js